import { createSelector } from '@reduxjs/toolkit';

import { DEFAULT_SCREEN_DIMENSIONS } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { ScreenDimensions } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { Template } from 'dashboard/models/template';
import { RootState } from 'dashboard/redux/store';
import { fetchScreenDimensionsMap } from 'dashboard/redux/thunk-actions/inquiry-template';

const getScreenDimensions = (state: RootState): ScreenDimensions =>
  state.inquiryTemplate.editorScreenDimensions;

const fetchScreenDimensions = (inquiryTemplateId: string): ScreenDimensions => {
  return fetchScreenDimensionsMap()?.[inquiryTemplateId] || DEFAULT_SCREEN_DIMENSIONS;
};

// current inquiry template
const getInquiryTemplate = (state: RootState): InquiryTemplate | Template =>
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  state.inquiryTemplate.inquiryTemplate;

/*
 * This selector should be in sync with the one in
 * front-end/dashboard/apps/InquiryTemplateEditor/InquiryTemplateSimulate/selectors/screenDimensions.ts
 * If you change one, please check if the other needs changes as well
 */
export const getScreenDimensionsLiveUpdated = createSelector(
  [getScreenDimensions, getInquiryTemplate],
  (screenDimensions, inquiryTemplate): ScreenDimensions => {
    return screenDimensions || fetchScreenDimensions(inquiryTemplate?.id);
  },
);
